import React from 'react'
import styles from './CAEJAnalysisMode.module.css'

const CAEJAnalysisMode = () => {
    return (
        <div>CAEJAnalysisMode</div>
    )
}

export default CAEJAnalysisMode